import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Link from "components/link";
import IconButton from "components/icon-button";
import { FormattedMessage } from "react-intl";
import Icon from "components/icon";
import { ConnectedPaginatedTable, TableIconCell, CustomTableRow } from "components/table";
import PropTypes from "prop-types";
import { HeaderCell } from "components/table";
import query from "./query";
import styles from "./styles.css.js";
import withStyles from "components/with-styles";

const Header = () => (
  <TableRow>
    <HeaderCell>
      <FormattedMessage id="app.page.user" />
    </HeaderCell>
    <TableIconCell />
  </TableRow>
);

const RowComponent = ({ item, classes }) => {
  const detailsUrl = `/user/details/${item.username}`;
  return (
    <CustomTableRow key={item.id} href={detailsUrl}>
      <TableCell>
        <div className={classes.title}>{item.username}</div>
        <div>{item.name}</div>
      </TableCell>
      <TableIconCell>
          <Link href={detailsUrl} target="_blank" rel="noopener">
              <IconButton>
                  <Icon name="launch" />
              </IconButton>
          </Link>
      </TableIconCell>
    </CustomTableRow>
  );
};

RowComponent.propTypes = {
  /**
   ** Elemento a representar en la fila de la tabla
   **/
  item: PropTypes.object,
};

const StyledRowComponent = withStyles(styles)(RowComponent);

const ContractPaginatedTable = ({ variables, debounce }) => (
  <ConnectedPaginatedTable
    variables={variables}
    gqlQuery={query}
    headerComponent={Header}
    rowComponent={StyledRowComponent}
    debounce={debounce}
    paginatedElementsHandler={data => data.customerUsers}
  />
);

ContractPaginatedTable.propTypes = {
  /**
   ** Objeto que contiene los filtrados de la búsqueda
   **/
  variables: PropTypes.object,
  /**
   * Debouncea o no la recarga de la query de la tabla
   **/
  debounce: PropTypes.bool,
};

export default ContractPaginatedTable;
